<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-align: center;">With thanks to my wife Sylvia, family, and friends for encouragement in getting me to finish this book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?19b69bb7